
import { AllLabels } from '@/interfaces';
import { labelsStore } from '@/store';
import { Component, Vue } from 'vue-property-decorator';
import Footer from '@/components/common/Footer.vue';
import ProcessingPageContent from './ProcessingPageContent.vue';


@Component({
  components: {
    Footer,
    ProcessingPageContent,
  }
})
export default class ProcessingPage extends Vue {

  public get labels(): AllLabels {
    return labelsStore.labels;
  }
}

